export function PageHeader({
  eyebrow,
  title,
  description,
  actions = null,
  className = "",
  hero = false,
}) {
  return (
    <header
      className={`suite-page-header ${
        hero ? "suite-page-header--hero" : ""
      } ${className}`.trim()}
    >
      <div>
        {eyebrow && <span className="suite-eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="suite-page-actions">{actions}</div>}
    </header>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  description,
  actions = null,
  className = "",
}) {
  return (
    <div className={`suite-section-header ${className}`.trim()}>
      <div>
        {eyebrow && <span className="suite-eyebrow">{eyebrow}</span>}
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="suite-section-actions">{actions}</div>}
    </div>
  );
}
